/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var EXAM_MODALITY_ENUM;
(function (EXAM_MODALITY_ENUM) {
    EXAM_MODALITY_ENUM["CR"] = "CR";
    EXAM_MODALITY_ENUM["CT"] = "CT";
    EXAM_MODALITY_ENUM["DR"] = "DR";
    EXAM_MODALITY_ENUM["DX"] = "DX";
    EXAM_MODALITY_ENUM["RF"] = "RF";
    EXAM_MODALITY_ENUM["RG"] = "RG";
    EXAM_MODALITY_ENUM["MG"] = "MG";
    EXAM_MODALITY_ENUM["MR"] = "MR";
    EXAM_MODALITY_ENUM["OT"] = "OT";
    EXAM_MODALITY_ENUM["PT"] = "PT";
    EXAM_MODALITY_ENUM["SC"] = "SC";
    EXAM_MODALITY_ENUM["US"] = "US";
    EXAM_MODALITY_ENUM["CT_SR"] = "CTSR";
})(EXAM_MODALITY_ENUM || (EXAM_MODALITY_ENUM = {}));
